import React from 'react';
import PageLayout from "../../components/PageLayout/PageLayout";
import '../bookpage.css'
import Title from '../../components/Title/Title';

export default function RegainSpirit() {
  return (
    <PageLayout>
      <div className="book-page">
        <Title title="Regain the fullness of the Spirit" />
        <blockquote>
          “And do not get drunk with wine, for that is dissipation, but be filled with the Spirit.” (Ephesians 5:18)
        </blockquote>

        <p>Jesus said that apart from Him we can do nothing (John 15:5). Yet many times we sin because we are trying to do things in our way own with our own strength. God saw fit in His marvelous plan of salvation to indwell each individual Christian with His Holy Spirit, a treasure that the Old Testament saints did not have available to them. God has given us unbelievable resources to walk with Him and know and obey His will.</p>
        <br />
        <p>We might look at certain individuals in the Old Testament who sinned and say they should have known better or done this or that. But we have much greater revelation and far greater resources available to us to obey the truth. And yet we likewise fail in similar ways! It is likely that God will judge us more severely, we who have greater knowledge, more Scripture, and examples of faithful individuals to follow, more freedom in society to choose our own paths, and most of all the power of His indwelling Holy Spirit.</p>
        <br />
        <p>We have no excuse to not overcome and live fully for Christ, and it is required of us. But we need to learn to rely on the Holy Spirit for guidance and strength and to rely on our own efforts. When we are filled with the Spirit, we will not sin. If we chose to sin, we quench the Spirit and no longer enjoy His fellowship and leading. Pray for God’s fullness to indwell you each day. “Walk by the Spirit, and you will not carry out the deeds of the flesh” (Galatians 5:16). There is no greater power for victory over sin than His indwelling Holy Spirit.</p>
        <br />

        <ul>
          <li>
            Learn what resources you have available to you in Christ and in the Holy Spirit.<br />
            <em>Romans 8:1-11, 2 Peter 1:3-4</em>
          </li>
          <br />
          <li>
            Abide in Christ.<br />
            <em>John 15:1-8, 1 John 2:6, 28, 3:6, 23-24, 4:11-16</em>
          </li>
          <br />
          <li>
            Walk in a manner worthy of Christ, by the Spirit, and you will not carry out the deeds of the flesh.<br />
            <em>Galatians 5:16-26, Ephesians 4:1-3, 5:18, Colossians 1:9-10</em>
          </li>
          <br />
          <li>
            Rejoice, and be thankful. Let your forbearing spirit be evident to all.<br />
            <em>Philippians 4:4-5, Colossians 3:15-17</em>
          </li>
          <br />
          <li>
            Strive for perfection and Christ-likeness in all things; be holy in all your behavior.<br />
            <em>Matthew 5:48, Ephesians 5:1, Colossians 1:28, 1 Peter 1:14-16</em>
          </li>
          <br />
          <li>
            Learn to daily put off the old and put on the new.<br />
            <em>Romans 13:14, 2 Corinthians 5:17, Galatians 5:24, Ephesians 4:22-24, Colossians 3:9-10</em>
          </li>
          <br />
          <li>
            Learn to daily cleanse yourself from youthful lusts.<br />
            <em>2 Corinthians 7:1, 2 Timothy 2:21-22, James 4:8, 1 Peter 2:11</em>
          </li>
          <br />
          <li>
            Learn to restrain your words and bridle your tongue.<br />
            <em>Proverbs 10:19, 17:27-28, 18:6-8, 19-21, 20:25, 29:20, Ephesians 5:4, James 1:19, 3:2-12</em>
          </li>
          <br />
          <li>
            Learn to control your anger.<br />
            <em>Proverbs 14:29, 16:32, 19:11, Ephesians 4:26-27, James 1:19-20</em>
          </li>
          <br />
          <li>
            Do not grieve or quench the Spirit.<br />
            <em>Ephesians 4:30, 1 Thessalonians 5:19</em>
          </li>
          <br />
          <li>
            Be sober-minded; do not be foolish, but understand the will of the Lord.<br />
            <em>Ephesians 5:17, 1 Thessalonians 5:6-8</em>
          </li>
        </ul>

      </div>
    </PageLayout>
  );
};
